module.exports = __webpack_public_path__ + "c7b9cf67a8508007a2414bc0681cea55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/no_user.jpg
// module id = 391
// module chunks = 0